import React from 'react';

import CheckCircleDisplay from 'ds/CheckCircleDisplay';
import Clickable from 'ds/Clickable';

export interface Props {
  checked: boolean;
  onChange: CheckcircleOnChange;
}
export interface OnChangeParams {
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>;
  checked: boolean;
}
export type CheckcircleOnChange = (params: OnChangeParams) => void;

const CheckCircle: React.FC<Props> = ({ checked, onChange }) => {
  return (
    <Clickable
      onClick={e => {
        onChange({ event: e, checked: !checked });
      }}
    >
      <CheckCircleDisplay checked={checked} size="sm" />
    </Clickable>
  );
};

export default CheckCircle;
